import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** /l/:code?s=qr|copy|share_native — lien court interne → /s/<slug> avec UTM (source = partage). */
export default function ShortLinkRedirect() {
  const { code } = useParams();
  const [params] = useSearchParams();
  const [error, setError] = useState(false);
  useEffect(() => {
    const src = params.get("s") || "direct";
    axios.get(`${API}/public/l/${encodeURIComponent(code)}`, { params: { src } })
      .then((r) => window.location.replace(r.data.redirect))
      .catch(() => setError(true));
  }, [code, params]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6" data-testid="short-link-redirect">
      {error ? (
        <div className="text-center max-w-sm">
          <div className="font-bold text-slate-900 text-lg">Lien introuvable</div>
          <p className="text-slate-500 text-sm mt-2">Ce lien de simulation n'existe pas ou n'est plus actif.</p>
        </div>
      ) : <div className="text-slate-400 text-sm animate-pulse">Redirection…</div>}
    </div>
  );
}
